import { selectCurrentOrder } from 'pages/newOrder/newOrder.selectors';
import { setDriverTip } from 'pages/newOrder/newOrder.slice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function useDriverTip() {
  const dispatch = useDispatch();
  const { driverTip } = useSelector(selectCurrentOrder);

  const setDriverTipHandler = useCallback(
    (tip: number) => {
      dispatch(setDriverTip(tip));
    },
    [dispatch]
  );

  const handleTipSelection = useCallback(
    (tip: number) => {
      if (driverTip === tip) {
        setDriverTipHandler(0);
      } else {
        setDriverTipHandler(tip);
      }
    },
    [driverTip, setDriverTipHandler]
  );

  return { handleTipSelection, driverTip };
}
